export default "__VITE_ASSET__e562a524__"